import { render } from "./WaInputBar.vue?vue&type=template&id=d18e1d84"
import script from "./WaInputBar.vue?vue&type=script&lang=js"
export * from "./WaInputBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__